export enum DynamicComponentType {
  MULTI_SELECT = 'multi-select',
  SINGLE_SELECT = 'single-select',
  TEXTBOX = 'text',
  DATE = 'date',
};
